


















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Config } from "@/shared/config";

@Component ({})

export default class Saml extends Vue {
}
